module.exports = __webpack_public_path__ + "static/together_event01_icon03-70d775e534e7a5951c38effc1f0c62ef.png";